import useRecentSearches from '@propertypal/shared/src/hooks/useRecentSearches';
import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { Property } from '@propertypal/shared/src/types/property';
import { SuperFeatureProperty } from '@propertypal/shared/src/types/superFeature';
import platform from '@propertypal/shared/src/utils/platform';
import Head from 'next/head';
import { GetServerSideProps } from 'next/types';
import React, { FunctionComponent } from 'react';
import generateMetaTags from '../../components/layout/MetaTags';
import NewHomesLandingPage from '../../components/new-homes/NewHomesLandingPage';
import { IMAGE_LOCATOR_LARGE } from '../../constants/imageLocator';
import { requireAuthToken } from '../../utils/auth';

interface Props {
  superfeatures: SuperFeatureProperty[];
  featured?: Property[];
  totalViewings?: number;
  loggedIn: boolean;
}

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx, store) => {
  const newHomes = await axios(
    {
      method: 'GET',
      url: `${API_URL}/new-homes-landing-page?imageLocator=${encodeURIComponent(IMAGE_LOCATOR_LARGE)}`,
    },
    store.dispatch,
    ctx,
  );

  return {
    props: {
      superfeatures: newHomes.data.superfeatures.sort(() => Math.random() - 0.5),
      featured: newHomes.data.featured,
      totalViewings: newHomes.data?.showHomes?.showHomes?.length || newHomes.data?.totalShowHomes || 0,
    },
  };
});

const metaData = {
  title: `New Homes :: New Builds :: Northern Ireland - ${platform.title}`,
  // eslint-disable-next-line max-len
  description: `Find Your Perfect New Home With ${platform.title}. Search For These And Tens Of Thousands Of Other Properties Across Northern Ireland`,
  url: `/new-homes/northern-ireland`,
};

const NewHomes: FunctionComponent<Props> = (props) => {
  const images = props.superfeatures?.map((row) => row?.url || row.image?.url);
  const recentSearches = useRecentSearches();

  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <NewHomesLandingPage
        images={images}
        superfeatures={props.superfeatures}
        featured={props.featured}
        totalViewings={props.totalViewings}
        loggedIn={props.loggedIn}
        {...recentSearches}
      />
    </>
  );
};

export default NewHomes;
